var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "flag-icons-ai",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h512v512H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#49497d",
    d: "m384 212.7 2 2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m386 212.7 2 2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#262678",
    d: "m379.9 214.7 2 2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#808067",
    d: "m382 214.7 2 2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m388 214.7 2 2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m312.9 216.8 2 2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1b74",
    d: "m375.9 216.8 2 2z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6c70",
    d: "m377.9 216.8 2 2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#cc3",
    d: "M316.5 220.4c0 52.5-6 111.6 33 152.7 8 8.4 23.4 27.7 36.5 27 13.7-.8 31.4-21.1 39.2-31 34-44.8 28.7-98.2 29.8-150.2-15.3 6.9-23 9.2-36.4 9-10 1-25.3-5.5-34.5-10-6 4-14.7 8.9-30.4 9.4-18 .8-23.8-2.3-37.2-7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#99994e",
    d: "m390 216.8 2 2z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#49497d",
    d: "m392 216.8 2 2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m455 216.8 2 2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m315 218.8 2 2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6c70",
    d: "m317 218.8 2 2z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a3a7c",
    d: "m319 218.8 2 2z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1b74",
    d: "m371.8 218.8 2 2z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6c70",
    d: "m373.8 218.8 2 2z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m375.9 218.8 2 2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d045",
    d: "m384 218.8 2 2z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m392 218.8 2 2z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d5b",
    d: "m394 218.8 2 2z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a3a7c",
    d: "m396.2 218.8 2 2z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#262678",
    d: "m448.9 218.8 2 2z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#53527c",
    d: "m451 218.8 2 2z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d5b",
    d: "m453 218.8 2 2z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#737370",
    d: "m323 220.9 2 2z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#53527c",
    d: "m325 220.9 2 2z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1b74",
    d: "m327 220.9 2 2z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#262678",
    d: "m367.7 220.9 2 2z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6c70",
    d: "m369.8 220.9 2 2z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m371.8 220.9 2 2z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e59d",
    d: "m382 220.9 2 2z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M320.6 226a509 509 0 0 0 4 88.2c4.9 15.4 4.2 23.9 11.3 33l99-.7c6-9.7 10.5-24.4 11-30.3 5.6-29.7 5.7-62.6 5.9-92a62 62 0 0 1-35.7 7.4 69 69 0 0 1-30.5-9.2c-9.5 5.6-12.8 8.2-28.4 8.9-12.2.6-22 1.6-36.6-5.2z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d7",
    d: "m386 220.9 2 2z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d868",
    d: "m388 220.9 2 2z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m396.2 220.9 2 2z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#99994e",
    d: "m398.2 220.9 2 2z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "#49497d",
    d: "m400.2 220.9 2 2z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m402.2 220.9 2 2z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a3a7c",
    d: "m442.9 220.9 2 2z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "#667",
    d: "m444.9 220.9 2 2z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "#99994e",
    d: "m446.9 220.9 2 2z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m448.9 220.9 2 2-2-2m-121.8 2 2 2z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "#99994e",
    d: "m329.2 222.9 2 2z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6c70",
    d: "m331.2 222.9 2 2z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "#49497d",
    d: "m333.2 222.9 2 2z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1b74",
    d: "m335.2 222.9 2 2-2-2m26.4 0 2 2z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "#53527c",
    d: "m363.6 222.9 2 2-2-2z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d5b",
    d: "m365.7 222.9 2 2z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m367.7 222.9 2 2z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e59d",
    d: "m377.9 222.9 2 2z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbfaf2",
    d: "m379.9 222.9 2 2z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d2",
    d: "m390 222.9 2 2z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d868",
    d: "m392 222.9 2 2z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m402.2 222.9 2 2z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6c70",
    d: "m404.3 222.9 2 2z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a3a7c",
    d: "m406.3 222.9 2 2z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m432.7 222.9 2 2z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "#32327b",
    d: "m434.7 222.9 2 2z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m436.8 222.9 2 2z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "#808067",
    d: "m438.8 222.9 2 2z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m442.2 223.5 1.3.7z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "#dddc7a",
    d: "m319 224.9 2 2z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d045",
    d: "m321 224.9 2 2z"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m336.6 225.5 1.4.7z"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "#808067",
    d: "m339.3 224.9 2 2z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "#667",
    d: "m341.3 224.9 2 2z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m343.4 224.9 2 2z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "#49497d",
    d: "m345.4 224.9 2 2z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "#737370",
    d: "m357.6 224.9 2 2z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "#99994e",
    d: "m359.6 224.9 2 2z"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m361.6 224.9 2 2z"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e59d",
    d: "m373.8 224.9 2 2z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbfaf2",
    d: "m375.9 224.9 2 2z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d2",
    d: "m394 224.9 2 2z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d868",
    d: "m396.2 224.9 2 2z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m407.6 225.5 1.4.7-1.3-.7z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "#808067",
    d: "m410.4 224.9 2 2z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "#667",
    d: "m412.4 224.9 2 2z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m414.4 224.9 2 2z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a3a7c",
    d: "m416.5 224.9 2 2z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m425.9 225.5 1.4.7z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "#737370",
    d: "m428.6 224.9 2 2z"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "#99994e",
    d: "m430.6 224.9 2 2-2-2z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m432.7 224.9 2 2z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "#dddc7a",
    d: "m448.9 224.9 2 2z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d045",
    d: "m451 224.9 2 2z"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d7",
    d: "m323 226.9 2 2z"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0dea1",
    d: "m325 226.9 2 2z"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "#dddc7a",
    d: "m327 226.9 2 2z"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d868",
    d: "m367.7 226.9 2 2z"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e3af",
    d: "m369.8 226.9 2 2z"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6e4",
    d: "m398.2 226.9 2 2z"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e18c",
    d: "m400.2 226.9 2 2z"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4d456",
    d: "m440.8 226.9 2 2z"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e18c",
    d: "m442.9 226.9 2 2z"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "#eeedc1",
    d: "m444.9 226.9 2 2z"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d2",
    d: "m331.2 228.9 2 2z"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0dea1",
    d: "m333.2 228.9 2 2z"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "#dddc7a",
    d: "m335.2 228.9 2 2z"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d045",
    d: "m337.3 228.9 2 2z"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "#dddc7a",
    d: "m361.6 228.9 2 2z"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e3af",
    d: "m363.6 228.9 2 2-2-2z"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6e4",
    d: "m365.7 228.9 2 2z"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "#eeedc1",
    d: "m404.3 228.9 2 2z"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e18c",
    d: "m406.3 228.9 2 2z"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4d456",
    d: "m408.3 228.9 2 2z"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d868",
    d: "m432.7 228.9 2 2z"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e18c",
    d: "m434.7 228.9 2 2z"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "#eeedc1",
    d: "m436.8 228.9 2 2z"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6e4",
    d: "m438.8 228.9 2 2z"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d7",
    d: "m341.3 230.9 2 2-2-2z"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d2",
    d: "m343.4 230.9 2 2-2-2z"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "#eeedc1",
    d: "m345.4 230.9 2 2-2-2z"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d2",
    d: "m354.9 231.6 1.3.7z"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbfaf2",
    d: "m357.6 230.9 2 2-2-2z"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m367.7 230.9 4 4v-4h-4z"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d7",
    d: "m412.4 230.9 2 2-2-2z"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d2",
    d: "m414.4 230.9 2 2-2-2z"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e3af",
    d: "m416.5 230.9 2 2-2-2z"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e59d",
    d: "m419.9 231.6 1.3.7-1.4-.7z"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0dea1",
    d: "m422.6 230.9 2 2-2-2z"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d2",
    d: "m425.9 231.6 1.4.7z"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbfaf2",
    d: "m428.6 230.9 2 2-2-2z"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m363.6 233 2 2-2-2z"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m365.7 233 2 2z"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m363.6 235 2 2-2-2z"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m367.7 235 2 2z"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m363.6 237 2 2-2-2z"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m367.7 237 2 2z"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m361.6 239 2 2-2-2m8.2 0 2 2z"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m379.9 239 2 2z"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m382 239 2 2z"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m390 239 2 2z"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m392 239 2 2z"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m361.6 241 2 2z"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m369.8 241 2 2z"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m373.8 241 2 2z"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m375.9 241 2 2z"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m377.9 241 2 2z"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb755",
    d: "m394 241 2 2z"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m396.2 241 2 2z"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m361.6 243.2 2 2z"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m371.8 243.2 2 2-2-2m26.4 0 2 2z"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m400.2 243.2 2 2z"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6e4",
    d: "m319 245.2 2 2z"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m361.6 245.2 2 2z"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m402.2 245.2 2 2z"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m404.3 245.2 2 2z"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m361.6 247.2 2 2z"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb755",
    d: "m408.3 247.2 2 2z"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m410.4 247.2 2 2z"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m359.6 249.3 2 2z"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m361.6 249.3 2 2z"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m418.5 249.3 2 2z"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m420.6 249.3 2 2z"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m422.6 249.3 2 2z"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m424.6 249.3 4 4z"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m426.6 249.3 2 2z"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m359.6 251.3 2 2z"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m388 251.3 2 2z"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m390 251.3 2 2zm8 0 2.2 2-2-2z"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m400.2 251.3 2 2z"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m357.6 253.3 2 2z"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m384 253.3 2 2z"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m386 253.3 2 2z"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m402.2 253.3 2 2z"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m404.3 253.3 2 2z"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m416.5 253.3 2 2z"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb755",
    d: "m418.5 253.3 2 2z"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m420.6 253.3 2 2z"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m422.6 253.3 2 2z"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m357.6 255.3 2 2z"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m382 255.3 2 2z"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m406.3 255.3 2 2z"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m414.4 255.3 2 2z"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m355.6 257.4 2 2z"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m379.9 257.4 2 2z"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m408.3 257.4 2 2z"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m414.4 257.4 2 2z"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m355.6 259.4 2 2z"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m377.9 259.4 2 2-2-2m32.5 0 2 2z"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m414.4 259.4 2 2z"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6e4",
    d: "m319 261.4 2 2z"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m355.6 261.4 2 2z"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m377.9 261.4 2 2z"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m410.4 261.4 2 2z"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m416.5 261.4 2 2z"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m353.6 263.5 2 2z"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m375.9 263.5 2 2z"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m412.4 263.5 2 2z"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m416.5 263.5 2 2z"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m353.6 265.5 2 2z"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m375.9 265.5 2 2z"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m386 265.5 2 2z"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m388 265.5 2 2z"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m390 265.5 2 2z"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m392 265.5 2 2z"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m412.4 265.5 2 2z"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m414.4 265.5 2 2z"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m416.5 265.5 2 2z"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m353.6 267.5-2.1 6 2-6z"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m373.8 267.5 2 2z"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m375.9 267.5 2 2z"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m386 267.5 2 2z"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m394 267.5 2 2z"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m396.2 267.5 2 2z"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m414.4 267.5 2 2z"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "m416.5 267.5 2 2z"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m419.2 268.9.6 1.3z"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m377.9 269.5 2 2z"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m379.9 269.5 2 2z"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m382 269.5 2 2z"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m384 269.5 2 2z"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m386 269.5 2 2z"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m388 269.5 2 2z"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m398.2 269.5 2 2z"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m400.2 269.5 2 2z"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m402.2 269.5 2 2z"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m404.3 269.5 2 2z"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m407.6 270.2 1.4.7-1.3-.7z"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m410.4 269.5 2 2z"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m416.5 269.5 2 2z"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m329.2 271.6 2 2z"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m331.2 271.6 2 2z"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb755",
    d: "m384 271.6 2 2z"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m388 271.6 2 2z"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m390 271.6 2 2z"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m406.3 271.6 2 2z"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m408.3 271.6-2 4z"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m412.4 271.6 2 2z"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m414.4 271.6 2 2z"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m416.5 271.6 2 2z"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m329.2 273.6 2 2z"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m331.2 273.6 4 4z"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m333.2 273.6 2 2zm18.3 0 2 2z"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m353.6 273.6 2 2z"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m371.8 273.6 2 2z"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m373.8 273.6 2 2z"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m375.9 273.6 2 2z"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m382 273.6 2 2z"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m384 273.6 2 2z"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m392 273.6 2 2z"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m408.3 273.6 2 2z"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m410.4 273.6 2 2z"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m418.5 273.6 2 2z"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m329.2 275.6 2 2z"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m335.2 275.6 2 2z"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m345.4 275.6 2 2z"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m355.6 275.6 2 2z"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m358.9 276.3 1.4.7z"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m371.8 275.6 2 2z"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m377.9 275.6 2 2z"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m394 275.6 2 2z"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m408.3 275.6 2 2z"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb755",
    d: "m420.6 275.6 2 2z"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m422.6 275.6 2 2z"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    fill: "#53527c",
    d: "m312.9 277.7 2 2z"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb755",
    d: "m331.2 277.7 2 2z"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m335.2 277.7 2 2z"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m343.4 277.7 2 2z"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m347.4 277.7 2 2z"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m349.5 277.7 2 2z"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m355.6 277.7 2 2z"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m357.6 277.7 2 2z"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m359.6 277.7 2 2z"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m369.8 277.7 2 2z"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m396.2 277.7 2 2z"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m422.6 277.7 2 2z"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d5b",
    d: "m455 277.7 2 2z"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e3af",
    d: "m319 279.7 2 2z"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m331.2 279.7 2 2z"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m337.3 279.7 2 2z"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m343.4 279.7 2 2z"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m347.4 279.7 2 2z"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m355.6 279.7 2 2z"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m369.8 279.7 2 2-2-2m28.4 0 2 2z"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m424.6 279.7 2 2z"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m333.2 281.7 2 2z"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m339.3 281.7 2 2z"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m341.3 281.7 2 2z"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m345.4 281.7 2 2z"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m347.4 281.7 2 2z"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m357.6 281.7 2 2z"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m369.8 281.7 2 2z"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m400.2 281.7 2 2z"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m426.6 281.7 2 2z"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m333.2 283.8 2 2z"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m345.4 283.8 2 2z"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m357.6 283.8 2 2z"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m367.7 283.8 2 2-2-2m34.5 0 2 2z"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m428.6 283.8 2 2z"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m335.2 285.8 2 2z"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m343.4 285.8 2 2z"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m359.6 285.8 2 2z"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m367.7 285.8 2 2z"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m402.2 285.8 2 2z"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m428.6 285.8 2 2z"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3d079",
    d: "m319 287.9 2 2z"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m335.2 287.9 2 2zm24.4 0 2 2z"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m367.7 287.9 2 2-2-2m34.5 0 2 2z"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m430.6 287.9 2 2-2-2z"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d7",
    d: "m448.9 287.9 2 2z"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m455.7 289.2.7 1.3z"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d868",
    d: "m319.6 291.2.8 1.4-.7-1.4z"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m335.2 289.9 2 2z"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m400.2 289.9 2 2z"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m402.2 289.9 2 2z"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m430.6 289.9 2 2-2-2z"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d2",
    d: "m449.6 291.2.7 1.4z"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m335.2 291.9 2 2z"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m398.2 291.9 2 2z"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m400.2 291.9 2 2z"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m406.3 291.9-2 4z"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb755",
    d: "m408.3 291.9 2 2z"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m432.7 291.9 2 2z"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m434.7 291.9 2 2z"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    fill: "#53527c",
    d: "m455 291.9 2 2z"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    fill: "#808067",
    d: "m315.6 295.3.7 1.3z"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m337.3 293.9 2 2-2-2m6 0 2 2-2-2z"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m365.7 293.9 2 2z"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m398.2 293.9 2 2z"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m406.3 293.9 2 2z"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m410.4 293.9 2 2z"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb755",
    d: "m436.8 293.9 2 2z"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m438.8 293.9 4 4z"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e59d",
    d: "m449.6 295.3.7 1.3z"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    fill: "#32327b",
    d: "m455.7 295.3.7 1.3z"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb755",
    d: "m338 297.3.6 1.4z"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m345.4 295.9 2 2z"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m365.7 295.9 2 2z"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m398.2 295.9 2 2z"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m402.2 295.9 2 2z"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m404.3 295.9 2 2z"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m410.4 295.9 2 2z"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m438.8 295.9 2 2z"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    fill: "#667",
    d: "m315 297.9 2 2-2-2z"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6e4",
    d: "m321 297.9 2 2-2-2z"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m345.4 297.9 2 2-2-2z"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m361.6 297.9 2 2-2-2z"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m363.6 297.9 2 2-2-2z"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m365.7 297.9 2 2-2-2z"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m400.2 297.9 2 2-2-2z"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m402.2 297.9 2 2-2-2m10.2 0 2 2z"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m440.8 297.9 2 2-2-2z"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    fill: "#dddc7a",
    d: "m448.9 297.9 2 2-2-2z"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m315 300 2 2z"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d2",
    d: "m321 300 2 2z"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m338 301.4.6 1.3z"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m345.4 300 2 2z"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m365.7 300 2 2z"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m367.7 300 2 2z"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m371.8 300 2 2z"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m373.8 300 2 2z"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m400.2 300 2 2z"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m402.2 300 2 2z"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m412.4 300 2 2z"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m414.4 300 2 2z"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m442.9 300 2 2z"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d868",
    d: "m448.9 300 2 2z"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a3a7c",
    d: "m315 302 2 2z"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e3af",
    d: "m321 302 2 2z"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m347.4 302 2 2z"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m367.7 302 2 2z"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m373.8 302 2 2z"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m375.9 302 2 2z"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m398.2 302 2 2z"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m400.2 302 2 2z"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m402.2 302 2 2z"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m414.4 302 2 2-2-2m16.3 0 2 2z"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m432.7 302 2 2z"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m434.7 302 2 2z"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m436.8 302 2 2z"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb755",
    d: "m438.8 302 2 2z"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m442.9 302 2 2z"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    fill: "#808067",
    d: "m453 302 2 2z"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    fill: "#32327b",
    d: "m315 304 2 2z"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m317.6 305.4.7 1.4-.6-1.4z"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e59d",
    d: "m321 304 2 2z"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m337.3 304 2 2z"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m349.5 304 2 2z"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m369.8 304 2 2z"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m375.9 304 2 2z"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m394 304 2 2z"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m396.2 304 2 2z"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m404.3 304 2 2z"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m414.4 304 2 2z"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m430.6 304 2 2-2-2z"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m440.8 304 2 2z"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m442.9 304 2 2z"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    fill: "#737370",
    d: "m453 304 2 2z"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d868",
    d: "m321 306 2 2z"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m337.3 306 2 2z"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m351.5 306 2 2-2-2m18.3 0 2 2z"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m375.9 306 2 2z"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m386 306 2 2z"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m388 306 2 2z"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m390 306 2 2z"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m392 306 2 2z"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m404.3 306 2 2z"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d2",
    d: "m446.9 306 2 2z"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m453 306 2 2z"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    fill: "#99994e",
    d: "m317 308 2 2z"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d045",
    d: "m321 308 2 2z"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m353.6 308 2 2z"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m355.6 308 2 2z"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m369.8 308 2 2z"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb755",
    d: "m377.9 308 2 2z"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m379.9 308 2 2z"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m382 308 2 2z"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m384 308 2 2z"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m400.2 308 2 2z"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m402.2 308 2 2z"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m430.6 308 2 2-2-2z"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0dea1",
    d: "m446.9 308 2 2z"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a3a7c",
    d: "m453 308 2 2z"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    fill: "#737370",
    d: "m317 310.2 2 2z"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbfaf2",
    d: "m323 310.2 2 2z"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m339.3 310.2 2 2z"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m357.6 310.2 2 2z"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m359.6 310.2 2 2z"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m361.6 310.2 2 2z"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m363.6 310.2 2 2-2-2z"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m365.7 310.2 2 2z"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m367.7 310.2 2 2z"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m369.8 310.2 2 2z"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m398.2 310.2 2 2z"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m400.2 310.2 2 2z"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m428.6 310.2 2 2z"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e18c",
    d: "m446.9 310.2 2 2z"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m451.6 311.5.7 1.4z"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    fill: "#262678",
    d: "m453 310.2 2 2z"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m317 312.2 2 2z"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d2",
    d: "m323 312.2 2 2z"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m339.3 312.2 2 2z"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m394 312.2 2 2z"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m396.2 312.2 2 2z"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m414.4 312.2 2 2z"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m428.6 312.2 2 2z"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4d456",
    d: "m446.9 312.2 2 2z"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    fill: "#32327b",
    d: "m317 314.2 2 2z"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e59d",
    d: "m323 314.2 2 2z"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m339.3 314.2 2 2z"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m341.3 314.2 2 2z"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m394 314.2 2 2z"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m414.4 314.2 2 2z"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m428.6 314.2 2 2z"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    fill: "#808067",
    d: "m451 314.2 2 2z"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m317 316.2 2 2z"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m319 316.2 2 2z"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d868",
    d: "m323 316.2 2 2z"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m341.3 316.2 2 2z"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m412.4 316.2 2 2z"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m426.6 316.2 2 2z"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d2",
    d: "m444.9 316.2 2 2z"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m451 316.2 2 2z"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d5b",
    d: "m319 318.3 2 2z"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m343.4 318.3 2 2z"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m384 318.3 2 2z"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m386 318.3 2 2z"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m389.4 318.9 1.4.7z"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m410.4 318.3-2 4z"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m412.4 318.3 2 2z"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m424.6 318.3-2 4z"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e59d",
    d: "m444.9 318.3 2 2z"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a3a7c",
    d: "m451 318.3 2 2z"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    fill: "#667",
    d: "m319 320.3 2 2z"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d2",
    d: "m325 320.3 2 2z"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m345.4 320.3 2 2z"
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m384 320.3 2 2z"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m386 320.3 2 2z"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m388 320.3 2 2z"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m390 320.3 2 2z"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m410.4 320.3 2 2z"
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m424.6 320.3 2 2z"
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9d868",
    d: "m444.9 320.3 2 2z"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m448.9 320.3 2 2z"
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m451 320.3 2 2z"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a3a7c",
    d: "m319 322.3 2 2z"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e59d",
    d: "m325 322.3 2 2z"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m347.4 322.3 4 4z"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m349.5 322.3 2 2z"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m388 322.3 2 2z"
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m406.3 322.3 2 2z"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m408.3 322.3 2 2z"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m420.6 322.3 2 2z"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m422.6 322.3 2 2z"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbfaf2",
    d: "m442.9 322.3 2 2z"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d5b",
    d: "m448.9 322.3 2 2z"
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m319 324.4 2 2z"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m321 324.4 2 2z"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4d456",
    d: "m325 324.4 2 2z"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m386 324.4 2 2z"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m404.3 324.4 2 2z"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m406.3 324.4 2 2z"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m418.5 324.4 2 2z"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    fill: "#eeedc1",
    d: "m442.9 324.4 2 2z"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m448.9 324.4 2 2z"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    fill: "#737370",
    d: "m321 326.4 2 2z"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6e4",
    d: "m327 326.4 2 2z"
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m349.5 326.4 2 2z"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m382 326.4 2 2z"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m384.6 327.8.7 1.3z"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m400.2 326.4 2 2z"
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m402.2 326.4 2 2z"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m414.4 326.4 2 2z"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m416.5 326.4 2 2z"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3d079",
    d: "m442.9 326.4 2 2z"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m446.9 326.4 2 2z"
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    fill: "#262678",
    d: "m448.9 326.4 2 2z"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    fill: "#49497d",
    d: "m321 328.4 2 2z"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    fill: "#e0dea1",
    d: "m327 328.4 2 2z"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m347.4 328.4 2 2z"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m375.9 328.4 2 2z"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m377.9 328.4 2 2z"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m379.9 328.4 2 2z"
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m386 328.4 2 2z"
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m412.4 328.4 2 2z"
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    fill: "#99994e",
    d: "m446.9 328.4 2 2z"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m321 330.5 2 2z"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m323 330.5 2 2z"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    fill: "#d4d456",
    d: "m327 330.5 2 2z"
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m345.4 330.5 2 2z"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m347.4 330.5 2 2-2-2m10.2 0 2 2z"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m359.6 330.5 2 2z"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m361.6 330.5 2 2z"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m369.8 330.5 2 2z"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m371.8 330.5 2 2z"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m373.8 330.5 2 2z"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m390 330.5 2 2z"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m392 330.5 2 2z"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m394 330.5 2 2z"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbc477",
    d: "m396.2 330.5 2 2z"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m398.2 330.5 2 2z"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m408.3 330.5 2 2z"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m410.4 330.5 2 2z"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e3af",
    d: "m440.8 330.5 2 2z"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    fill: "#667",
    d: "m446.9 330.5 2 2z"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    fill: "#737370",
    d: "m323 332.5 2 2z"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f1d7",
    d: "m329.2 332.5 2 2z"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m343.4 332.5 2 2z"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m353.6 332.5 2 2z"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m355.6 332.5 2 2z"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m357.6 332.5 2 2z"
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    fill: "#fea522",
    d: "m406.3 332.5 2 2z"
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m408.3 332.5 2 2z"
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    fill: "#dddc7a",
    d: "m440.8 332.5 2 2z"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m444.9 332.5 2 2z"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    fill: "#262678",
    d: "m446.9 332.5 2 2z"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    fill: "#49497d",
    d: "m323 334.5 2 2z"
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m325.8 335.9.7 1.3z"
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3d079",
    d: "m329.2 334.5 2 2z"
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d099",
    d: "m345.4 334.5 2 2z"
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb144",
    d: "m347.4 334.5 2 2z"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m349.5 334.5 2 2z"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m351.5 334.5 2 2z"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    fill: "#fef8f1",
    d: "m353.6 334.5 2 2z"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8dcbb",
    d: "m398.2 334.5 2 2z"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcf1e4",
    d: "m406.3 334.5 2 2z"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    fill: "#f6f6e4",
    d: "m438.8 334.5 2 2z"
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d5b",
    d: "m444.9 334.5 2 2z"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbfaf2",
    d: "m331.2 336.5 2 2z"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbbe66",
    d: "m398.2 336.5 2 2z"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m404.3 336.5 2 2z"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    fill: "#e1e18c",
    d: "m438.8 336.5 2 2z"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    fill: "#49497d",
    d: "m444.9 336.5 2 2z"
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m325 338.6 2 2z"
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e59d",
    d: "m331.2 338.6 2 2z"
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m398.2 338.6 2 2z"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    fill: "#fdab33",
    d: "m402.2 338.6 2 2z"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbfaf2",
    d: "m436.8 338.6 2 2z"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m442.9 338.6 2 2z"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m444.9 338.6 2 2z"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1b74",
    d: "m325 340.6 2 2z"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m327 340.6 2 2z"
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d045",
    d: "m331.2 340.6 2 2z"
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m396.2 340.6 2 2z"
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe9f11",
    d: "m400.2 340.6 2 2z"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbead6",
    d: "m402.2 340.6 2 2z"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e59d",
    d: "m436.8 340.6 2 2z"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    fill: "#667",
    d: "m442.9 340.6 2 2z"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6c70",
    d: "m327 342.6 2 2z"
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e3af",
    d: "m333.2 342.6 2 2z"
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    fill: "#faca88",
    d: "m396.8 344 .7 1.4z"
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    fill: "#fae3c9",
    d: "m400.2 342.6 2 2z"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbfaf2",
    d: "m434.7 342.6 2 2z"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m440.8 342.6 2 2z"
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1b74",
    d: "m442.9 342.6 2 2-2-2m-115.8 2 2 2z"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m329.2 344.7 2 2z"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    fill: "#d0d045",
    d: "m333.2 344.7 2 2z"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    fill: "#fbfaf2",
    d: "m335.2 344.7 2 2z"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9d6aa",
    d: "m398.2 344.7 2 2z"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e59d",
    d: "m434.7 344.7 2 2z"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6c70",
    d: "m440.8 344.7 2 2-2-2m-111.6 2 2 2z"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    fill: "#8cbf84",
    d: "m335.2 346.7 2 2z"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    fill: "#0cf",
    d: "M336 346.7c7 14.8 32 49.8 51 49.2 18.7-.7 39.6-35 47.7-49.2z"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m438.8 346.7 2 2z"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1b74",
    d: "m440.8 346.7 2 2-2-2m-111.6 2 2 2z"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m331.2 348.7 2 2z"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    fill: "#adb333",
    d: "m335.2 348.7 2 2z"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    fill: "#1ac5b5",
    d: "m337.3 348.7 2 2z"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    fill: "#68b070",
    d: "m432.7 348.7 2 2z"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    fill: "#667",
    d: "m438.8 348.7 2 2z"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m331.2 350.8 2 2z"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    fill: "#7fb15c",
    d: "m337.3 350.8 2 2z"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    fill: "#27c2aa",
    d: "m430.6 350.8 2 2-2-2z"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m436.8 350.8-2 4z"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m438.8 350.8 2 2-2-2m-107.6 2 2 2z"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m333.2 352.8 4 4z"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    fill: "#34be9e",
    d: "m339.3 352.8 2 2z"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    fill: "#96b247",
    d: "m430.6 352.8 2 2-2-2z"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    fill: "#53527c",
    d: "m436.8 352.8 2 2z"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a3a7c",
    d: "m333.2 354.9 2 2z"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2b23d",
    d: "m339.3 354.9 2 2z"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    fill: "#0dc9c1",
    d: "m341.3 354.9 2 2z"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    fill: "#5bb47c",
    d: "m428.6 354.9 2 2z"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d5b",
    d: "m434.7 354.9 2 2z"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    fill: "#737370",
    d: "m335.2 356.9 2 2z"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    fill: "#74b166",
    d: "m341.3 356.9 2 2z"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    fill: "#27c2aa",
    d: "m426.6 356.9 2 2z"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m432.7 356.9-2 4z"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    fill: "#262678",
    d: "m434.7 356.9 2 2z"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m335.2 358.9 2 2z"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m337.3 358.9 4 4z"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    fill: "#42bb92",
    d: "m343.4 358.9 2 2z"
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    fill: "#0dc9c1",
    d: "m424.6 358.9 2 2z"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    fill: "#96b247",
    d: "m426.6 358.9 2 2z"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m432.7 358.9 2 2z"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a3a7c",
    d: "m337.3 360.9 2 2z"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    fill: "#adb333",
    d: "m343.4 360.9 2 2z"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    fill: "#27c2aa",
    d: "m345.4 360.9 2 2z"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    fill: "#74b166",
    d: "m424.6 360.9 2 2z"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d5b",
    d: "m430.6 360.9 2 2-2-2z"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6c70",
    d: "m339.3 362.9 2 2z"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    fill: "#96b247",
    d: "m345.4 362.9 2 2z"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    fill: "#0dc9c1",
    d: "m347.4 362.9 2 2z"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    fill: "#42bb92",
    d: "m422.6 362.9 2 2z"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m428.6 362.9-4 6 4-6z"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1b74",
    d: "m430.6 362.9 2 2-2-2z"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m339.3 364.9 2 2-2-2z"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d5b",
    d: "m341.3 364.9 2 2-2-2z"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    fill: "#7fb15c",
    d: "m347.4 364.9 2 2-2-2z"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    fill: "#34be9e",
    d: "m420.6 364.9 2 2-2-2z"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    fill: "#3a3a7c",
    d: "m428.6 364.9 2 2-2-2z"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1b74",
    d: "m341.3 367 2 2z"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m343.4 367 22.3 22.3z"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    fill: "#74b166",
    d: "m349.5 367 2 2z"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    fill: "#27c2aa",
    d: "m418.5 367 2 2z"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    fill: "#adb333",
    d: "m420.6 367 2 2z"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    fill: "#667",
    d: "m426.6 367 2 2z"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    fill: "#32327b",
    d: "m343.4 369 2 2z"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    fill: "#42bb92",
    d: "m351.5 369 2 2z"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    fill: "#0dc9c1",
    d: "m416.5 369-8.2 10.2 8.3-10.3z"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    fill: "#adb333",
    d: "m418.5 369 2 2z"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    fill: "#737370",
    d: "m424.6 369 2 2z"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    fill: "#49497d",
    d: "m345.4 371 2 2z"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    fill: "#42bb92",
    d: "m353.6 371 2 2z"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    fill: "#96b247",
    d: "m416.5 371 2 2z"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d5b",
    d: "m422.6 371-2 4z"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m424.6 371 2 2z"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    fill: "#53527c",
    d: "m347.4 373 2 2z"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    fill: "#42bb92",
    d: "m355.6 373 2 2z"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    fill: "#96b247",
    d: "m414.4 373 2 2z"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m422.6 373 2 2z"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6c70",
    d: "m349.5 375 2 2z"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    fill: "#42bb92",
    d: "m357.6 375 2 2z"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    fill: "#96b247",
    d: "m412.4 375 2 2z"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m418.5 375-4 6.2 4-6z"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    fill: "#262678",
    d: "m420.6 375 2 2z"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6c70",
    d: "m351.5 377.2 2 2z"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    fill: "#42bb92",
    d: "m359.6 377.2 2 2z"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    fill: "#96b247",
    d: "m410.4 377.2 2 2z"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    fill: "#262678",
    d: "m418.5 377.2 2 2z"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6c70",
    d: "m353.6 379.2 2 2z"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    fill: "#68b070",
    d: "m361.6 379.2 2 2z"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    fill: "#27c2aa",
    d: "m406.3 379.2 2 2z"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    fill: "#adb333",
    d: "m408.3 379.2 2 2z"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    fill: "#262678",
    d: "m416.5 379.2 2 2z"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    fill: "#667",
    d: "m355.6 381.2 2 2z"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    fill: "#74b166",
    d: "m363.6 381.2 2 2-2-2z"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    fill: "#34be9e",
    d: "m404.3 381.2 2 2z"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    fill: "#adb333",
    d: "m406.3 381.2 2 2z"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d5b",
    d: "m412.4 381.2-2 4z"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    fill: "#262678",
    d: "m414.4 381.2 2 2z"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    fill: "#49497d",
    d: "m357.6 383.2 2 2z"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    fill: "#96b247",
    d: "m365.7 383.2 2 2z"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    fill: "#0dc9c1",
    d: "m367.7 383.2 2 2z"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    fill: "#42bb92",
    d: "m402.2 383.2 2 2z"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m412.4 383.2 2 2z"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    fill: "#49497d",
    d: "m359.6 385.3 2 2z"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    fill: "#a2b23d",
    d: "m367.7 385.3 2 2z"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    fill: "#27c2aa",
    d: "m369.8 385.3 2 2z"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    fill: "#74b166",
    d: "m400.2 385.3 2 2z"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m406.3 385.3-6 8z"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    fill: "#808067",
    d: "m408.3 385.3 2 2z"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m410.4 385.3 2 2z"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    fill: "#262678",
    d: "m361.6 387.3 2 2z"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    fill: "#adb333",
    d: "m369.8 387.3 2 2z"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    fill: "#42bb92",
    d: "m371.8 387.3 2 2z"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    fill: "#0dc9c1",
    d: "m396.2 387.3 2 2z"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    fill: "#96b247",
    d: "m398.2 387.3 2 2z"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6c70",
    d: "m406.3 387.3 2 2z"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1b74",
    d: "m363.6 389.3 2 2-2-2z"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d5b",
    d: "m365.7 389.3 2 2z"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    fill: "#74b166",
    d: "m373.8 389.3 2 2z"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    fill: "#0dc9c1",
    d: "m375.9 389.3 2 2z"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    fill: "#34be9e",
    d: "m394 389.3 2 2z"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    fill: "#adb333",
    d: "m396.2 389.3 2 2z"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    fill: "#49497d",
    d: "m404.3 389.3 2 2z"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m365.7 391.4 2 2z"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    fill: "#6e6c70",
    d: "m367.7 391.4 2 2z"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m369.8 391.4 4 4z"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    fill: "#96b247",
    d: "m375.9 391.4 2 2z"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    fill: "#27c2aa",
    d: "m377.9 391.4 2 2z"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    fill: "#68b070",
    d: "m392 391.4 2 2z"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    fill: "#32327b",
    d: "m402.2 391.4 2 2z"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    fill: "#49497d",
    d: "m369.8 393.4 2 2z"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    fill: "#5bb47c",
    d: "m379.9 393.4 2 2z"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    fill: "#27c2aa",
    d: "m388 393.4 2 2z"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    fill: "#96b247",
    d: "m390 393.4 2 2z"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m396.2 393.4-2 4z"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    fill: "#808067",
    d: "m398.2 393.4 2 2z"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m400.2 393.4 2 2z"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    fill: "#262678",
    d: "m371.8 395.4 2 2z"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d8d5b",
    d: "m373.8 395.4 2 2z"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    fill: "#8bb252",
    d: "m382 395.4 2 2z"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    fill: "#1ac5b5",
    d: "m384 395.4 2 2z"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    fill: "#5bb47c",
    d: "m386 395.4 2 2z"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    fill: "#58587b",
    d: "m396.2 395.4 2 2z"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m373.8 397.5 2 2z"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    fill: "#667",
    d: "m375.9 397.5 2 2z"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m377.9 397.5 2 2z"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    fill: "#99994e",
    d: "m392 397.5 2 2z"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    fill: "#32327b",
    d: "m394 397.5 2 2-2-2m-16.1 2 2 2z"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    fill: "#99994e",
    d: "m379.9 399.5 2 2z"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m388 399.5 2 2z"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    fill: "#667",
    d: "m390 399.5 2 2z"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m392 399.5 2 2-2-2m-12.1 2 2 2z"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    fill: "#667",
    d: "m382 401.5 2 2z"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    fill: "#a4a43d",
    d: "m384 401.5 2 2z"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    fill: "#99994e",
    d: "m386 401.5 2 2z"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    fill: "#32327b",
    d: "m388 401.5 2 2z"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    fill: "#262678",
    d: "m384 403.5 2 2z"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    fill: "#0e0e6e",
    d: "m386 403.5 2 2z"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "M388 267.5c3.2 7.4 13.2 15.5 16 19.5-3.5 4-4.2 3.6-3.8 11 6-6.4 6.2-7 10.2-6.1 8.6 8.6 1.5 27-5.6 31-7.1 4.3-5.8-.1-16.5 5.2 4.9 4.2 10.6-.6 15.2.7 2.5 3-1.2 8.4.7 13.6 4-.4 3.6-8.7 4.6-11.7 3-11 21-18.6 21.9-28.7 3.8-1.7 7.5-.5 12 2-2.2-9.4-9.7-9.3-11.8-12.2-4.8-7.4-9.1-15.8-19.4-18-8-1.7-7.3.5-12.3-3-3.2-2.4-12.7-7-11.2-3.3z"
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M410.6 275.9a1.6 1.6 0 1 1-3.3 0 1.6 1.6 0 0 1 3.3 0z"
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "M362.9 298.8c5-6.2 7.6-19 9.8-23.2 5.2 1.2 5 2 11.5-1.8-8.5-2.4-9.2-2.2-10.2-6.1 3.6-11.7 23.2-14 30-9.6 7.2 4.3 2.7 5.2 12.4 12 1.4-6.2-5.5-9-6.5-13.6 1.5-3.7 8-3 11.6-7-2.2-3.5-9.3.8-12.4 1.4-11 2.5-26.3-9.8-35.6-6-3.3-2.5-4-6.4-4-11.7-7.1 6.5-3.5 13-5.2 16.3-4.2 7.7-9.7 15.5-6.8 25.6 2.2 7.8 3.8 6.2 3.2 12.3-.7 3.9-.4 14.5 2.2 11.4z"
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M359.8 274.9c.8-.4 1.8-.1 2.2.7a1.6 1.6 0 1 1-2.2-.7z"
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    fill: "#f90",
    d: "M404 303c-8-1-20.1 3.4-25 3.8-1.5-5.1-.8-5.5-7.4-9 2.3 8.6 2.8 9 0 12-11.8 2.9-24-12.7-23.8-20.8 0-8.3 3.2-5 4-17-6 2-4.8 9.5-8.3 12.8-4 .6-6.6-5.3-12-6.3-1.8 3.7 5.5 7.5 7.6 9.9 7.9 8.2 5.2 27.5 13.3 33.5-.4 4.2-3.4 6.8-8 9.4 9.3 2.9 13-3.7 16.7-4 8.8-.2 18.3.4 25.5-7.3 5.4-6 3.3-6.5 8.8-9 3.7-1.4 12.6-7.2 8.6-8z"
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M385.2 318.2a1.6 1.6 0 1 1 1.7-2.8 1.6 1.6 0 0 1-1.7 2.8z"
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h256v256H0z"
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M256 0v32l-95 96 95 93.5V256h-33.5L127 162l-93 94H0v-34l93-93.5L0 37V0h31l96 94 93-94z"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "m92 162 5.5 17L21 256H0v-1.5zm62-6 27 4 75 73.5V256zM256 0l-96 98-2-22 75-76zM0 .5 96.5 95 67 91 0 24.5z"
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M88 0v256h80V0zM0 88v80h256V88z"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    fill: "#c8102e",
    d: "M0 104v48h256v-48zM104 0v256h48V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.8b2ef8f76c8c1981c83eda6b1af1765a.svg";
export { ForwardRef as ReactComponent };